import { fetchJSON } from "Helper/apiHelper";
import { waitForEvent } from "@kluntje/js-utils/lib/dom-helpers";

/**
 * Global helper service to handle i18n strings
 */
export class I18nService {
  static _instance: I18nService;
  keys: Record<string, string>;
  loaded: boolean;
  whenReady: Promise<void>;
  _setReady!: Function;

  constructor() {
    this.keys = {};
    this.loaded = false;
    this.whenReady = new Promise(resolve => (this._setReady = resolve));
    this.loadStrings();
  }

  static getInstance(): I18nService {
    if (!I18nService._instance) {
      I18nService._instance = new I18nService();
    }
    return I18nService._instance;
  }

  /**
   * Return localized string for submitted key
   * @param {string} key
   * @returns {string} Either found localized string or key if no record was found
   */
  getKey(key: string): string {
    let value = key;
    if (this.keys.hasOwnProperty(key)) {
      value = this.keys[key];
    }
    return value;
  }

  async waitForJson(): Promise<void> {
    if (this.loaded === true) return;
    return await waitForEvent(window, "i18nkeysloaded");
  }

  /**
   * Load JSON with localized strings
   */
  private loadStrings(): void {
    fetchJSON(window.fraportTraveli18n).then(response => {
      this.loaded = true;
      this._setReady();
      this.keys = { ...response };
      window.dispatchEvent(new CustomEvent("i18nkeysloaded"));
    });
  }
}

I18nService.getInstance();
